import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import zh from "./locales/zh.json";
import hi from "./locales/hi.json";
import es from "./locales/es.json";
import ar from "./locales/ar.json";
import fr from "./locales/fr.json";
import sw from "./locales/sw.json";

const _urlLang = new URLSearchParams(window.location.search).get("lang");
const _supportedLangs = ["en","es","fr","zh","hi","sw","ar"];
const _initLang = (_urlLang && _supportedLangs.includes(_urlLang)) ? _urlLang : "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
      hi: { translation: hi },
      es: { translation: es },
      ar: { translation: ar },
      fr: { translation: fr },
      sw: { translation: sw },
    },
    lng: _initLang,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,  // React already escapes
    },
  });

export default i18n;
